import React from 'react'

const About = () => {
    return (
        <>
         <h1>About section</h1>   
        </>
    )
}

export default About;
